export enum MaritalStatus {
    Single = 1,
    Married = 2,
    Widower = 3,
    Divorced = 4
}